import type { ILegalDocs, IHelpCenterLinks, TextThemeProvider } from '../src/getTextThemeProvider';

const COMMUNITY_HOME_HREF = 'https://community.solovis.com';
const ARTICLE_BASE_HREF = 'https://solovis.my.site.com/support/s/article';

const helpCenterLinks: IHelpCenterLinks = {
  INTERCOM_HELP_ALL_HREF: COMMUNITY_HOME_HREF,
  FACTOR_EXPOSURE_HREF: `${ARTICLE_BASE_HREF}/What-is-factor-exposure-β-and-how-is-it-calculated`,
  FACTOR_CONTRIBUTION_TO_RISK_HREF: `${ARTICLE_BASE_HREF}/What-is-factor-contribution-to-risk-and-how-is-it-calculated`,
  FACTOR_CONTRIBUTION_TO_RETURN_HREF: `${ARTICLE_BASE_HREF}/What-is-factor-contribution-to-return-and-how-is-it-computed`,
  INTERCOM_HELP_HREF: `${ARTICLE_BASE_HREF}/How-Risk-Pro-Selects-Relevant-Factors`,
  METRIC_DEFINITIONS_HREF: `${ARTICLE_BASE_HREF}/Metric-Definitions`,
  FORECASTS_FAQ_HREF: `${ARTICLE_BASE_HREF}/How-to-configure-and-use-forecasts`,
  DEMO_PORTFOLIO_FAQ_HREF: `${ARTICLE_BASE_HREF}/Demo-portfolio-information`,
  DEMO_PRIVATE_PORTFOLIO_FAQ_HREF: `${ARTICLE_BASE_HREF}/Private-Asset-Demo-Portfolio-Information`,
  STUDIO_FAQ_HREF: `${ARTICLE_BASE_HREF}/How-to-create-and-configure-reports-in-Studio-and-Report-Lab`,
  BENCHMARK_FAQ_HREF: `${ARTICLE_BASE_HREF}/How-to-Set-and-Create-Benchmarks`,
  FORECAST_RETURN_DEF_HREF: `${ARTICLE_BASE_HREF}/Metric-Definitions`,
  EXCESS_RETURN_DEF_HREF: `${ARTICLE_BASE_HREF}/What-are-relative-metrics-and-how-are-they-computed`,
  TRACKING_ERROR_DEF_HREF: `${ARTICLE_BASE_HREF}/What-are-relative-metrics-and-how-are-they-computed`,
  INFORMATION_RATIO_DEF_HREF: `${ARTICLE_BASE_HREF}/What-are-relative-metrics-and-how-are-they-computed`,
  MAX_UNDERPERFORMANCE_DEF_HREF: `${ARTICLE_BASE_HREF}/What-are-relative-metrics-and-how-are-they-computed`,
  HISTORICAL_RISK_STATISTICS_HREF: `${ARTICLE_BASE_HREF}/Historical-Risk-Statistics`,
  PORTFOLIO_LAB_FAQ_HREF: `${ARTICLE_BASE_HREF}/How-does-Optimization-and-Portfolio-Lab-work`,
  ADVANCED_SEARCH_FAQ_HREF: `${ARTICLE_BASE_HREF}/Data-Library-Advanced-Search-how-it-works-and-common-questions`,
  HOLDINGS_FAQ_HREF: `${ARTICLE_BASE_HREF}/How-does-Holdings-data-work-in-Studio-and-Report-Lab`,
  VENNCAST_FAQ_HREF: `${ARTICLE_BASE_HREF}/How-does-Risk-Pro-Cast-estimate-current-portfolio-performance`,
  CURRENCY_CONVERSION_ARTICLE_HREF: `${ARTICLE_BASE_HREF}/How-does-currency-conversion-work-in-Risk-Pro`,
  REBALANCE_STRATEGY_ARTICLE_HREF: `${ARTICLE_BASE_HREF}/How-does-portfolio-rebalancing-frequency-work`,
  INVESTMENT_CORRELATION_TOOL_HREF: `${ARTICLE_BASE_HREF}/How-does-the-Investment-Correlation-tool-work`,
  FACTOR_LENS_FAQ_HREF: `${ARTICLE_BASE_HREF}/How-the-Factor-Lens-Is-Constructed-and-Used-for-Analysis`,
  CURRENCY_FAQ_HREF: `${ARTICLE_BASE_HREF}/Which-currencies-does-Risk-Pro-support`,
  PROXY_FAQ_HREF: `${ARTICLE_BASE_HREF}/How-do-proxies-work`,
  DESMOOTHING_FAQ_HREF: `${ARTICLE_BASE_HREF}/How-to-Desmooth-Private-Asset-Returns`,
  INTERPOLATION_EXTRAPOLATION_FAQ_HREF: `${ARTICLE_BASE_HREF}/How-to-use-interpolation-and-extrapolation-for-private-asset-returns`,
  WORKSPACE_MANAGEMENT_ARTICLE_HREF: `${ARTICLE_BASE_HREF}/How-to-invite-teammates-and-manage-workspace-members`,
  GROWTH_SIMULATOR_FAQ_HREF: `${ARTICLE_BASE_HREF}/How-does-Asset-Growth-Simulator-work`,
  SCENARIO_ANALYSIS_FAQ_HREF: `${ARTICLE_BASE_HREF}/How-to-use-stress-testing-tools`,
  SENSITIVITY_ANALYSIS_FAQ_HREF: `${ARTICLE_BASE_HREF}/How-does-Sensitivity-Analysis-work`,
  NOTABLE_PERIODS_FAQ_HREF: `${ARTICLE_BASE_HREF}/How-does-the-Notable-Historical-Periods-feature-work`,
  FACTOR_PERIODS_SOURCES_HREF: `${ARTICLE_BASE_HREF}/Sources-for-Notable-Factor-Performance-Periods`,
  CATEGORIES_FAQ_HREF: `${ARTICLE_BASE_HREF}/What-are-investment-categories-and-how-are-they-calculated`,
  FACTOR_ALERTS_FAQ_HREF: `${ARTICLE_BASE_HREF}/How-to-Use-the-Factor-Lens-Tab`,
  HISTORICAL_DRAWDOWN_FAQ_HREF: `${ARTICLE_BASE_HREF}/How-does-the-Historical-Drawdown-and-Rally-Scanner-work`,
  ACCESSING_ANALYSES_FAQ_HREF: `${ARTICLE_BASE_HREF}/How-to-save-access-and-export-analyses`,
  INVESTMENT_UPLOADER_FAQ_HREF: `${ARTICLE_BASE_HREF}/How-to-upload-investment-NAVs-in-bulk-or-for-a-single-portfolio`,
  RETURNS_UPLOADER_FAQ_HREF: `${ARTICLE_BASE_HREF}/Returns-Uploader-FAQ`,
  MASTER_PORTFOLIO_ARTICLE_HREF: `${ARTICLE_BASE_HREF}/Getting-started-in-Risk-Pro-upload-data-and-build-your-portfolio`,
  ADDEPAR_HELP_HREF: `${ARTICLE_BASE_HREF}/How-to-set-up-the-Addepar-integration-in-Risk-Pro`,
  COMMON_BENCHMARKS_HELP_HREF: `${ARTICLE_BASE_HREF}/Common-benchmarks-reference`,
  PORTFOLIO_COMPARISON_HELP_HREF: `${ARTICLE_BASE_HREF}/How-to-compare-portfolio-allocation-changes`,
  PRIVATE_ASSET_LAB_HELP_HREF: `${ARTICLE_BASE_HREF}/Feature-Overview-Private-Asset-Lab`,
  PEER_GROUP_ANALYSIS_HELP_HREF: `${ARTICLE_BASE_HREF}/How-does-Peer-Group-Analysis-work`,
  PRIVATE_ASSET_UPLOADER_FAQ_HREF: `${ARTICLE_BASE_HREF}/Uploading-Private-Asset-Data-and-Creating-a-Private-Asset-Portfolio`,
  PRIVATE_ASSET_CASH_FLOW_HELP_HREF: `${ARTICLE_BASE_HREF}/How-the-Cash-Flow-Pacing-Model-Projects-Private-Asset-Cash-Flows`,
  PRIVATE_PERFORMANCE_HELP_HREF: `${ARTICLE_BASE_HREF}/How-Performance-Metrics-and-PMEs-Are-Calculated-for-Private-Assets`,
  PORTFOLIO_CONSTRUCTION_FAQ_HREF: `${ARTICLE_BASE_HREF}/How-to-Build-and-Configure-a-Portfolio`,
  STUDIO_REPORT_LAB_AIS_FAQ_HREF: `${ARTICLE_BASE_HREF}/How-to-create-and-configure-reports-in-Studio-and-Report-Lab`,
  MISSING_INVESTMENTS_FAQ_HREF: `${ARTICLE_BASE_HREF}/Investments-or-portfolios-deleted-unexpectedly-from-the-Data-Library`,
  PUBLIC_PRIVATE_ASSET_GROWTH_HREF: `${ARTICLE_BASE_HREF}/How-the-Total-Portfolio-Asset-Growth-Simulation-Works`,
  MULTI_PORTFOLIO_UPLOADER_FAQ_HREF: `${ARTICLE_BASE_HREF}/How-does-Portfolio-Builder-work`,
  ANALYSIS_PERIOD_HELP_HREF: `${ARTICLE_BASE_HREF}/How-is-the-analysis-period-adjusted-in-Risk-Pro`,
  HISTORICAL_PORTFOLIOS_HELP_HREF: `${ARTICLE_BASE_HREF}/How-do-Historical-portfolios-work`,
  DESMOOTHING_HELP_HREF: `${ARTICLE_BASE_HREF}/How-to-Desmooth-Private-Asset-Returns`,
  ADVISORY_FEES_HELP_HREF: `${ARTICLE_BASE_HREF}/How-to-set-advisory-fees-for-a-portfolio-in-Report-Lab`,
  TAX_RATE_HELP_HREF: `${ARTICLE_BASE_HREF}/Tax-Impact-Analysis-setup-data-requirements-and-methodology`,
  REDISTRIBUTION_HELP_HREF: `${ARTICLE_BASE_HREF}/Restricted-data-in-Report-Lab`,
  DISCLOSURE_AND_DISCLAIMER_HREF: `${ARTICLE_BASE_HREF}/Important-Disclosure-and-Disclaimer-Information`,
};

const rebrandTermsAndConditions = {
  baseUrl: '/api/legal/doc/rebrand-subscriber-agreement',
  titles: [
    {
      language: 'EN',
      text: 'Terms and Conditions',
    },
  ],
};

const rebrandedLegalDocuments: ILegalDocs = {
  COOKIE_POLICY: {
    baseUrl: '/api/legal/doc/rebrand-cookie-policy',
    titles: [
      {
        language: 'EN',
        text: 'Cookie Policy',
      },
      {
        language: 'JA',
        text: 'クッキーポリシー',
      },
    ],
  },
  PRIVACY_POLICY_LINK: rebrandTermsAndConditions,
  SUBSCRIBER_AGREEMENT_LINK: rebrandTermsAndConditions,
  USER_AGREEMENT_LINK: undefined,
  SERVICE_TIERS_LINK: undefined,
};

const RiskProTextMap: TextThemeProvider = {
  MarcomSiteUrl: 'https://go.solovis.com/risk-pro',
  AppTitle: 'Risk Pro',
  appTitleFullName: 'Solovis Risk Pro',
  companyName: 'Solovis',
  HelpCenterUrl: COMMUNITY_HOME_HREF,
  VenncastName: 'Risk Pro Cast',
  vdparName: 'Daily Private Asset Returns',
  factorLensName: 'factor lens',
  factorLensNameTitleCase: 'factor lens',
  factorLensShortName: 'factor lens',
  askAiName: 'Ask Risk Pro',
  brandProvidedLabel: 'Risk Pro-provided',
  downloadBackupCodesFileName: 'riskpro-backup-codes.txt',
  downloadComparisonFileName: 'riskpro_comparison',
  downloadDocumentsZipFileName: 'riskpro_files_export',
  HelpCenterLinks: helpCenterLinks,
  legalDocuments: rebrandedLegalDocuments,
  supportEmail: 'support@solovis.com',
  salesEmail: 'sales@solovis.com',
  operatorNameWithDefinition: 'Star Acquisition LLC ("Provider")',
  operatorShortName: 'Provider',
  copyrightEntity: 'Solovis Risk Pro',
  trademarkText: '',
  conflictsDisclosurePrint: '',
  conflictsDisclosureScreen: '',
};

export default RiskProTextMap;
